import { List, Record } from 'immutable';
import { ActionPropertyItem, IActionPropertyItem, ActionPropertyItemFactoryFromJS } from '.';
import { ReadonlyRecord } from '@bimser/core';

export interface IBaseActionItem {
	key: string;
	text: string;
}

export interface IActionItem extends IBaseActionItem {
	property?: Array<IActionPropertyItem>;
}

export interface ReadOnlyActionItem extends IBaseActionItem {
	property?: List<ActionPropertyItem>;
}

export type ActionItem = ReadonlyRecord<ReadOnlyActionItem>;

export const ActionItemFactory = Record<ReadOnlyActionItem>({
	key: null,
	text: null,
	property: List()
});

export const ActionItemFactoryFromJS = function (data: IActionItem) {
	let property: Array<ActionPropertyItem> = Array();

	if (data.property && data.property.length) {
		property =
			data.property && data.property.length
				? data.property.map(function (value: IActionItem) {
						return ActionPropertyItemFactoryFromJS(value);
				  })
				: [];
	}

	return ActionItemFactory({
		key: data.key,
		text: data.text,
		property: List(property)
	});
};
